export const width = 400;
export const height = 400;
export const innerHeight = height - 2;

export const devicePixelRatio = window.devicePixelRatio || 1;
